import React, { createContext, useContext } from 'react';

interface EventStyle {
  id: number;
  backgroundColor?: string;
  backgroundUrl?: string;
  backgroundPosition?: string;
  backgroundTiled?: boolean;
  headerColor?: string;
  textColor?: string;
  customFont?: string;
}

interface EventContextType {
  eventSlug: string;
  style?: EventStyle;
}

const EventContext = createContext<EventContextType | undefined>(undefined);

export const EventProvider: React.FC<{ 
  eventSlug: string; 
  style?: EventStyle;
  children: React.ReactNode 
}> = ({ 
  eventSlug, 
  style,
  children 
}) => {
  return (
    <EventContext.Provider value={{ eventSlug, style }}>
      {children}
    </EventContext.Provider>
  );
};

export const useEventContext = () => {
  const context = useContext(EventContext);
  if (!context) {
    throw new Error('useEventContext must be used within EventProvider');
  }
  return context;
};